module.exports = __webpack_public_path__ + "img/memory_mob.fbebaf7f.svg";